import { useQuery } from '@tanstack/react-query';
import { uomReferenceApi, type UomQueryParams } from '@/lib/api/services/uom-reference.api';

/**
 * The fixed unit reference tables behind the "UoM & pack size" pickers
 * ("UoM Reference Tables" §1–4) are seeded, not tenant data — fetched once
 * and cached for the session, like `useUnits`.
 */
export function useUoms(params?: UomQueryParams, enabled = true) {
  return useQuery({
    queryKey: ['uoms', params ?? {}],
    queryFn: () => uomReferenceApi.getUoms(params),
    enabled,
    staleTime: Infinity,
  });
}

export function usePackContainers(enabled = true) {
  return useQuery({
    queryKey: ['pack-containers'],
    queryFn: () => uomReferenceApi.getPackContainers(),
    enabled,
    staleTime: Infinity,
  });
}
